<template>
    <div>
        <div class="card">
            <div class="card-header">班级学员信息</div>
            <div class="card-body" v-if="classStudentData.length === 0">
                <div class="alert alert-warning mb-0">没有报名/报到的学生数据</div>
            </div>
            <table v-else class="table table-bordered mb-0">
                <tbody class="table-info">
                <tr>
                    <th class="text-center align-middle" style="width: 15%">报名人数</th>
                    <td class="text-left align-middle" style="width: 15%">{{studentCount.signInCount}}</td>
                    <th class="text-center align-middle" style="width: 15%">确认人数</th>
                    <td class="text-left align-middle" style="width: 15%">{{studentCount.confirmCount}}</td>
                    <th class="text-center align-middle" style="width: 15%">报到人数</th>
                    <td class="text-left align-middle" style="width: 15%">{{studentCount.checkInCount}}</td>
                </tr>
                </tbody>
            </table>
            <table v-if="classStudentData.length !== 0" class="table table-bordered table-striped mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 5%">序号</th>
                    <th class="text-center align-middle" style="width: 8%">姓名</th>
                    <th class="text-center align-middle" style="width: 5%">性别</th>
                    <th class="text-center align-middle" style="width: 23%">学校</th>
                    <template v-if="classState===classStateData.V2_SIGNIN">
                        <th class="text-center align-middle" style="width: 12%">院校审核</th>
                        <!-- 2025-12-25 经毕老师确认及教育厅沟通结果，去除主管部门确认环节 -->
                        <!-- <th class="text-center align-middle" style="width: 8%">省厅审核</th> -->
                        <th class="text-center align-middle" style="width: 18%">报名时间</th>
                        <th class="text-center align-middle" style="width: 10%">状态</th>
                        <th class="text-center align-middle" style="width: 15%" v-if="userType != userTypeData.ADMIN">操作</th>
                    </template>
                    <template v-else>
                        <th class="text-center align-middle" style="width: 10%">手机号码</th>
                        <th class="text-center align-middle" style="width: 10%">报到时间</th>
                        <th class="text-center align-middle" style="width: 8%">状态</th>
                        <th class="text-center align-middle" style="width: 6%">成绩</th>
                        <th class="text-center align-middle" style="width: 28%">操作</th>
                    </template>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(student, index) in displayStudentData" :key="student.studentClassId">
                    <td class="text-center align-middle">{{ index + 1 }}</td>
                    <td class="text-center align-middle">
                        <a href="#"
                           @click.prevent="linkShowStudentDetailInfo_Click(student.studentId)">{{ student.studentName }}</a>
                    </td>
                    <td class="text-center align-middle">{{ student.genderName }}</td>
                    <td class="text-left align-middle">
                        <a href="#"
                           @click.prevent="linkShowCollegeDetailInfo_Click(student.collegeId)">{{ student.collegeName }}</a>
                    </td>
                    <template v-if="classState===classStateData.V2_SIGNIN">
                        <td class="text-center align-middle">{{ student.collegeConfirmStateName }}</td>
                        <!-- 2025-12-25 经毕老师确认及教育厅沟通结果，去除主管部门确认环节 -->
                        <!-- <td class="text-center align-middle">{{ student.adminConfirmStateName }}</td> -->
                        <td class="text-center align-middle">{{ student.signInDateString }}</td>
                        <td class="text-center align-middle">{{ student.studentClassStateName }}</td>
                        <td class="text-center align-middle" v-if="userType != userTypeData.ADMIN">
                            <template>
                                <button class="btn btn-success btn-sm"
                                        :disabled="student.collegeConfirmState!==studentSignInConfirmState.V3_CONFIRM_TRUE"
                                        v-if="student.studentClassState===studentClassState.V1_NON_CONFIRM"
                                        @click="btnOrganConfirm_Click(student.studentClassId, true,
                                            student.studentId, student.studentName)">报名确认
                                </button>
                                <button class="btn btn-danger btn-sm"
                                        v-if="student.studentClassState===studentClassState.V2_CONFIRMED"
                                        @click="btnOrganConfirm_Click(student.studentClassId, false,
                                            student.studentId, student.studentName)">取消确认
                                </button>
                            </template>
                            <!-- 2025-12-25 经毕老师确认及教育厅沟通结果，去除主管部门确认环节 -->
                            <!-- <template v-if="userType === userTypeData.ADMIN">
                                <button class="btn btn-success btn-sm mr-2"
                                        :disabled="student.studentClassState !== studentClassState.V1_NON_CONFIRM"
                                        @click="btnAdminConfig_Click(student.studentClassId, true, '确定通过参训教师报名审核？',
                                        student.studentId, student.studentName)">
                                    审核通过
                                </button>
                                <button class="btn btn-danger btn-sm"
                                        :disabled="student.studentClassState !== studentClassState.V1_NON_CONFIRM"
                                        @click="btnAdminConfig_Click(student.studentClassId, false, '确定驳回参训教师报名审核？',
                                        student.studentId, student.studentName)">
                                    审核驳回
                                </button>
                            </template>
                            <template v-else>
                                <button class="btn btn-success btn-sm"
                                        :disabled="student.collegeConfirmState!==studentSignInConfirmState.V3_CONFIRM_TRUE ||
                                            student.adminConfirmState!==studentSignInConfirmState.V3_CONFIRM_TRUE"
                                        v-if="student.studentClassState===studentClassState.V1_NON_CONFIRM"
                                        @click="btnOrganConfirm_Click(student.studentClassId, true,
                                            student.studentId, student.studentName)">报名确认
                                </button>
                                <button class="btn btn-danger btn-sm"
                                        v-if="student.studentClassState===studentClassState.V2_CONFIRMED"
                                        @click="btnOrganConfirm_Click(student.studentClassId, false,
                                            student.studentId, student.studentName)">取消确认
                                </button>
                            </template> -->
                        </td>
                    </template>
                    <template v-else>
                        <td class="text-center align-middle">{{ student.mobilePhone }}</td>
                        <td class="text-center align-middle">{{ student.checkInDateString }}</td>
                        <td class="text-center align-middle">{{ student.studentClassStateName }}</td>
                        <td class="text-center align-middle">{{ student.score }}</td>
                        <td class="text-center align-middle">
                            <template
                                v-if="userType === userTypeData.ORGAN && classState===classStateData.V4_EXECUTE && student.studentClassState < studentClassState.V3_CHECK_IN">
                                <button class="btn btn-primary btn-sm mr-2"
                                        @click="btnOrganCheckIn_Click(student.studentClassId, student.studentId, student.studentName)">报到
                                </button>
                            </template>
                            <template v-if="student.studentClassState>=studentClassState.V3_CHECK_IN">
                                <button class="btn btn-danger btn-sm mr-2" v-if="userType === userTypeData.ORGAN" @click="btnCancelStudentClassState(student.studentClassId)" >取消报到</button>
                                <button class="btn btn-info btn-sm mr-2" @click="btnShowScoreDetail_Click(student.studentClassId)">成绩详情</button>
                                <button class="btn btn-info btn-sm mr-2" @click="btnShowStudentAchievementInfo_Click(student.studentId, student.projectId)">成果物详情</button>
                            </template>
                        </td>
                    </template>
                </tr>
                </tbody>
            </table>
            <div class="card-footer text-center">
                <!-- 2025-12-25 经毕老师确认及教育厅沟通结果，去除主管部门确认环节 -->
                <!-- <template v-if="userType === userTypeData.ADMIN && classState===classStateData.V2_SIGNIN && classStudentData.length !== 0">
                    <button class="btn btn-primary" @click="btnAdminConfirmAll_Click">全部审核通过</button>
                </template> -->
                <template v-if="userType === userTypeData.ORGAN">
                    <a class="btn btn-info mr-2" :href="URL_API + '/export/classStudentData?classId='+classId">导出所有确认学员信息</a>
                </template>
                <template v-if="userType === userTypeData.ORGAN && classState===classStateData.V2_SIGNIN && classStudentData.length !== 0">
                    <!-- <a class="btn btn-info mr-2" :href="URL_API + '/export/classStudentData?classId='+classId">导出所有确认学员信息</a> -->
                    <button class="btn btn-primary" @click="btnOrganConfirmAll_Click">全部确认报名</button>
                </template>
                <template v-if="userType === userTypeData.ORGAN && classState===classStateData.V4_EXECUTE && classStudentData.length !== 0">
                    <!-- <a class="btn btn-info mr-2" :href="URL_API + '/export/classStudentData?classId='+classId">导出所有确认学员信息</a> -->

                    <a class="btn btn-info mr-2" :href="URL_API + '/export/classScoreTemplate?classId='+classId+'&projectId='+projectId">下载成绩导入模板</a>
                    <button class="btn btn-danger" @click="btnUploadScoreData_Click">成绩数据导入</button>
                    <input type="file" name="uploadFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        style="display: none" ref="uploadFile" @change="uploadFileChange">
                </template>
            </div>
        </div>


        <b-modal v-model="isStudentDetailDialogOpen"
                 title="参训教师信息详情"
                 ok-title="确定" :ok-only="true" size="xl"
                 :no-close-on-backdrop="true">
            <person-basic-picture-info-view class="mb-3" :person-id="currentStudentId"></person-basic-picture-info-view>
            <person-contact-info-view class="mb-3" :person-id="currentStudentId"></person-contact-info-view>
            <person-work-info-view :person-id="currentStudentId"></person-work-info-view>
            <student-course-edit :student-id="currentStudentId" :can-edit="false"></student-course-edit>
        </b-modal>

        <b-modal v-model="isCollegeDetailDialogOpen"
                 title="参训教师院校信息详情"
                 ok-title="确定" :ok-only="true" size="lg"
                 :no-close-on-backdrop="true">
            <college-info-view :college-id="currentCollegeId"></college-info-view>
            <college-organ-contact-person-view class="mt-3" :owner-id="currentCollegeId"
                                               :person-type="personTypeData.COLLEGE_CONTACT"></college-organ-contact-person-view>
        </b-modal>

        <b-modal v-model="isStudentAchievementDialogOpen"
                 title="参训教师项目成果物信息详情"
                 ok-title="确定" :ok-only="true" size="lg"
                 :no-close-on-backdrop="true">
            <student-achievment-view :student-id="currentStudentId" :project-id="currentProjectId"></student-achievment-view>
        </b-modal>

        <b-modal v-model="isStudentScoreDetailDialogOpen"
                 title="参训教师成绩信息详情"
                 ok-title="确定" :ok-only="true" size="lg"
                 :no-close-on-backdrop="true">
            <student-score-edit :student-class-id="currentStudentClassId"></student-score-edit>
        </b-modal>
    </div>
</template>

<script>
import url from "@/utils/api/url";
import dictionary from "@/utils/dictionary";
import studyApi from "@/utils/api/study";

import PersonBasicPictureInfoView from "@/views/student/StudentBasicPictureInfoView";
import PersonContactInfoView from "@/views/student/StudentContactInfoView";
import PersonWorkInfoView from "@/views/student/StudentWorkInfoView";
import StudentCourseEdit from "@/components/user/StudentCourseEdit";
import CollegeInfoView from "@/components/user/CollegeInfoView";
import CollegeOrganContactPersonView from "@/components/user/CollegeOrganContactPersonView";
import StudentAchievmentView from "@/components/study/StudentAchievementView";
import commonApi from "@/utils/api/common";
import userApi from "@/utils/api/user";
import StudentScoreEdit from "@/components/study/StudentScoreEdit";

export default {
    name: "StudentClassDataManage",
    props: {
        classId: {type: String, required: true},
        userId: {type: String, required: true},
        userType: {type: Number, required: true},
        classState: {type: Number, required: true},
        batchId: {type: String, required: true},
    },
    components: {
        StudentScoreEdit,
        StudentAchievmentView,
        CollegeOrganContactPersonView,
        CollegeInfoView,
        PersonWorkInfoView,
        PersonContactInfoView,
        PersonBasicPictureInfoView,
        StudentCourseEdit
    },
    data: function () {
        return {
            URL_API: url.URL_API,

            classStateData: dictionary.projectClassState,
            userTypeData: dictionary.userType,
            personTypeData: dictionary.personType,
            studentSignInConfirmState: dictionary.studentSignInConfirmState,
            studentClassState: dictionary.studentClassState,

            classStudentData: [],

            projectId: '',

            currentStudentId: '',
            currentProjectId: '',
            currentCollegeId: '',
            currentStudentClassId: '',

            isStudentDetailDialogOpen: false,
            isCollegeDetailDialogOpen: false,
            isStudentAchievementDialogOpen: false,
            isStudentScoreDetailDialogOpen: false,
        };
    },
    computed: {
        displayStudentData() {
            return this.classStudentData.filter(item => {
                if (this.classState === this.classStateData.V2_SIGNIN) {
                    return true;
                } else {
                    return item.studentClassState > 1;
                }
            });
        },
        studentCount() {
            let result = {
                signInCount: 0,
                confirmCount: 0,
                checkInCount: 0
            };

            for (let item of this.classStudentData) {
                result.signInCount++;
                if (item.studentClassState >= this.studentClassState.V2_CONFIRMED) {
                    result.confirmCount++;
                    if (item.studentClassState >= this.studentClassState.V3_CHECK_IN) {
                        result.checkInCount++;
                    }
                }
            }
            return result;
        },
    },
    mounted() {
        this.getStudentClassDataByClassId();
    },
    methods: {
        getStudentClassDataByClassId() {
            studyApi.studentClass.getStudentClassDataByClassId(this.classId).then(res => {
                this.classStudentData = res.data;
                if (this.classStudentData.length !== 0){
                    this.projectId = this.classStudentData[0].projectId;
                }
            });
        },

        btnAdminConfig_Click(studentClassId, confirmState, message, studentId, studentName) {
            if (confirm(message)) {
                this.updateStudentClassState(studentClassId, this.userTypeData.ADMIN, confirmState, false, studentId, studentName);
            }
        },
        btnAdminConfirmAll_Click() {
            if (confirm('是否确认通过所有院校已审核的报名学员信息？')) {
                let students = this.displayStudentData.filter(item => {
                    return item.collegeConfirmState===dictionary.studentSignInConfirmState.V3_CONFIRM_TRUE && item.adminConfirmState===dictionary.studentSignInConfirmState.V1_NON_CONFIRM;
                }).map(item => {
                    return {
                        studentClassId: item.studentClassId,
                        studentId: item.studentId,
                        studentName: item.studentName
                    };
                });
                for (let item of students) {
                    this.updateStudentClassState(item.studentClassId, this.userTypeData.ADMIN, true, false, item.studentId, item.studentName);
                }
            }
        },


        btnOrganConfirm_Click(studentClassId, confirmState, studentId, studentName) {
            const handleConfirm = () => {
                if (confirm(confirmState ? '确认参训教师报名信息？' : '取消参训教师确认报名信息？')) {
                    this.updateStudentClassState(studentClassId, this.userTypeData.ORGAN, confirmState, false, studentId, studentName);
                }
            };
            if (confirmState) {
                let info = { batchId: this.batchId, studentId: studentId };
                studyApi.studentClass.verifyStudentClassState(info).then(resp => {
                    if (resp.data >= 1) {
                        alert('已有基地确认该学员报名，请勿重复确认！');
                        return;
                    }
                    handleConfirm();
                }).catch(err => {
                    console.error('校验报名状态失败：', err);
                    alert('校验报名信息失败，请重试！');
                });
            } else {
                handleConfirm();
            }
        },
        async btnOrganConfirmAll_Click() {
            if (confirm('是否确认通过所有院校及主管部门已审核的报名学员信息？')) {
                let students = this.displayStudentData.filter(item => {
                    if(item.collegeConfirmState===dictionary.studentSignInConfirmState.V3_CONFIRM_TRUE &&
                    // 2025-12-25 经毕老师确认及教育厅沟通结果，去除主管部门确认环节
                    //    item.adminConfirmState===dictionary.studentSignInConfirmState.V3_CONFIRM_TRUE &&
                       item.studentClassState===dictionary.studentClassState.V1_NON_CONFIRM){
                        return {
                            studentClassId: item.studentClassId,
                            studentId: item.studentId,
                            studentName: item.studentName
                        };
                    }
                });
              for (let item of students) {
                try {
                    let info = { batchId: this.batchId, studentId: item.studentId };
                    const resp = await studyApi.studentClass.verifyStudentClassState(info);
                    if (resp.data >= 1) {
                        continue;
                    }
                    this.updateStudentClassState(item.studentClassId, this.userTypeData.ORGAN, true, false, item.studentId, item.studentName);
                } catch (error) {
                    console.error(`校验学员${item.studentId}状态失败：`, error);
                    continue;
                }
              }
            }
        },

        btnOrganCheckIn_Click(studentClassId, studentId, studentName) {
            if (confirm('确认参训教师已报到？', studentId, studentName)) {
                this.updateStudentClassState(studentClassId, this.userTypeData.ORGAN, false, true, studentId, studentName);
            }
        },

        btnCancelStudentClassState(studentClassId){
            if(confirm('确认取消该参训教师报到？')){
                studyApi.studentClass.cancelStudentClassState(studentClassId).then(resp => {
                    if(resp.data  == 1){
                        alert('取消学员报到成功！');
                    } else {
                        alert('取消学员报到失败！');
                    }
                this.getStudentClassDataByClassId();
            })
            }
        },

        updateStudentClassState(studentClassId, userType, confirm, checkIn, studentId, studentName) {
            let info = {studentClassId, userType, confirm, checkIn};
            studyApi.studentClass.updateStudentClassStateInfo(info).then(res => {
                this.getStudentClassDataByClassId();

                let msgInfo = {
                    fromUserId: this.$store.state.userInfo.userId,
                    fromUserName: this.$store.state.userInfo.userName,
                    fromUserType: this.$store.state.userType,
                    toUserId: studentId,
                    toUserName: studentName,
                    toUserType: dictionary.userType.STUDENT,
                    messageTitle: '参训报名状态变更',
                    messageContent: '您当前的参训报名状态已变更，请到项目报名信息页面查看'
                };
                commonApi.message.insertMessageInfo(msgInfo).then(res => {
                });
            });
        },

        linkShowStudentDetailInfo_Click(studentId) {
            this.currentStudentId = studentId;
            this.isStudentDetailDialogOpen = true;
        },
        linkShowCollegeDetailInfo_Click(collegeId) {
            this.currentCollegeId = collegeId;
            this.isCollegeDetailDialogOpen = true;
        },

        btnShowStudentAchievementInfo_Click(studentId, projectId) {
            this.currentStudentId = studentId;
            this.currentProjectId = projectId;
            this.isStudentAchievementDialogOpen = true;
        },


        btnUploadScoreData_Click() {
            this.$refs.uploadFile.click();
        },
        uploadFileChange($event) {
            let file = $event.target.files[0];
            commonApi.file.uploadFile(file, 'ImportData').then(result => {
                let info = {
                    fileName: result.data.physicalAddress,
                    projectId: this.projectId
                };

                studyApi.studentClass.importStudentClassScoreData(info).then(res => {

                    this.getStudentClassDataByClassId();
                });
            });
        },

        btnShowScoreDetail_Click(studentClassId) {
            this.currentStudentClassId = studentClassId;
            this.isStudentScoreDetailDialogOpen = true;
        }
    }
}
</script>

<style scoped>

</style>
